var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookOpen = function SvgIconBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.25A1.75 1.75 0 0 0 1.25 6v12A1.75 1.75 0 0 0 3 19.75h6a2 2 0 0 1 2 2 1 1 0 1 0 2 0 2 2 0 0 1 2-2h6A1.75 1.75 0 0 0 22.75 18V6A1.75 1.75 0 0 0 21 4.25h-6a4 4 0 0 0-3 1.354A4 4 0 0 0 9 4.25zm10 4v10.036a4 4 0 0 1 2-.536h5.75V6.25H15a2 2 0 0 0-2 2m-2 0a2 2 0 0 0-2-2H3.25v11.5H9a4 4 0 0 1 2 .536z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBookOpen;